import { render, staticRenderFns } from "./journal-pending.vue?vue&type=template&id=4d4e0da9&scoped=true"
import script from "./journal-pending.vue?vue&type=script&lang=js"
export * from "./journal-pending.vue?vue&type=script&lang=js"
import style0 from "./journal-pending.vue?vue&type=style&index=0&id=4d4e0da9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4e0da9",
  null
  
)

export default component.exports